export const env = {
    apiUrl: process.env.REACT_APP_API_URI,
    baseUrl: process.env.REACT_APP_BASE_URI
}
